import React from 'react'
import { View, StyleSheet, ViewPropTypes } from 'react-native'
import PropTypes from 'prop-types'

import IconButton from '../IconButton'

const NavigationTopbar = ({ onGoBack, containerStyle, showMap }) => {
  return (
    <View
      style={[
        styles.container,
        containerStyle
      ]}
    >
      <IconButton
        icon='LeftArrow'
        onPress={onGoBack}
        color={showMap ? 'BUNKER' : 'GALLERY'}
        iconColor={showMap ? 'CATSKILL_WHITE' : 'SLATE_GRAY_TEXT'}
        size={30}
        iconSize={16}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 10
  }
})

NavigationTopbar.propTypes = {
  onGoBack: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  showMap: PropTypes.bool
}

NavigationTopbar.defaultProps = {
  onGoBack: () => {},
  containerStyle: null
}

export default NavigationTopbar
